import type { EatingPreferences } from '@/types/eatingPreferences'
import type { BaseSliceState } from '../../types'

export interface EatingPreferencesState extends BaseSliceState {
  preferences: EatingPreferences | null
}

export enum EatingPreferencesActionTypes {
  SET_PREFERENCES = 'eatingPreferences/set',
  SET_ERROR = 'eatingPreferences/error',
  CLEAR = 'eatingPreferences/clear'
}

export type EatingPreferencesAction =
  | { type: EatingPreferencesActionTypes.SET_PREFERENCES; payload: EatingPreferences | null }
  | { type: EatingPreferencesActionTypes.SET_ERROR; payload: string }
  | { type: EatingPreferencesActionTypes.CLEAR }
